import Vue from 'vue';
import api from '../../api';
import _ from 'lodash';
import router from '../../router';
import { dispatchesQueries, mutatesQueries, updatePagination } from '../helper';

const default_query = {
  search: { order_by: 'created_at', dir: 'desc' },
  advert: { order_by: 'created_at', dir: 'desc' },
  preference: { order_by: 'created_at', dir: 'desc' },
};

const state = {
  query: default_query,
  item: null,
  pagination: null,
  search_pagination: null,
  preferences_pagination: null,
  tenant_preferences_pagination: null,
  // B
  fetching: false,
  fetched: false,
  // R
  // instance_loading: false,
  // instance_loaded: false,
  // E-A
  // instance_saving: false,
  // instance_saved: false,
  // D
  // instance_deleting: false,
  // instance_deleted: false,,
};

const actions = {
  ...dispatchesQueries(default_query),

  fetch: function(context, type) {
    const query = context.state.query;
    const promise = api.subscriptions.index(query[type] || {}, type);
    context.commit('handleStatus', { fetching: true });
    promise
      .then((response) => {
        context.commit('handlePaginationResults', { data: response.data, type });
        context.commit('handleStatus', { fetched: true });
      })
      .catch((error) => {
        context.commit('handleStatus', { fetched: false });
      })
      .then(() => {
        context.commit('handleStatus', { fetching: false });
      });
  },
};

const mutations = {
  ...mutatesQueries(),

  handleLoadingStatus: function(state, { action, status }) {
    _.set(state, `progress.${action}`, status);
  },

  handlePaginationResults: function(state, payload) {
    if (payload.type == 'search') {
      _.set(state, `search_pagination`, payload.data);
    } else if (payload.type == 'preference') {
      _.set(state, `preferences_pagination`, payload.data);
    } else {
      _.set(state, `tenant_preferences_pagination`, payload.data);
    }
  },

  handleStatus: function(state, payload) {
    _.each(payload, (value, key) => {
      _.set(state, key, value);
    });
  },
};

const getters = {
  pagination: (state) => {
    return (type) => {
      if (type == 'search') {
        return _.get(state, 'search_pagination', null);
      } else if (type == 'preference') {
        return _.get(state, 'preferences_pagination', null);
      } else {
        return _.get(state, 'tenant_preferences_pagination', null);
      }
    };
  },
  preference_match: (state) => {
    return _.get(state, 'pagination', null);
  },
  tenant_preferences: (state) => {
    return _.get(state, 'pagination', null);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
